/* Granatelli sticky filter bar
   Pins .gm-filter-bar to the top of the viewport from the moment it scrolls
   into view and keeps it there permanently — even while the footer is visible
   (the bar overlays the top of the footer when scrolled to the bottom).

   How:
   - When scroll position >= bar's natural top → add .gm-filter-bar--fixed
     (switches the bar to position: fixed at top: 0). A spacer div inflates to
     match the bar's height so the page layout doesn't jump.
   - When scrolled back above the natural position → remove the class and
     deflate the spacer; bar returns to normal flow.
   - No footer collision logic — the bar always stays at top: 0 once scrolled.
*/
(function () {
  'use strict';

  function init() {
    var bar = document.querySelector('.gm-filter-bar');
    if (!bar || bar.__gmFilterBarStickyInit) return;
    bar.__gmFilterBarStickyInit = true;

    var spacer = document.createElement('div');
    spacer.className = 'gm-filter-bar-spacer';
    spacer.style.height = '0';
    bar.parentNode.insertBefore(spacer, bar);

    var barHeight = bar.offsetHeight;
    var initialTop = 0;

    function recalc() {
      var wasFixed = bar.classList.contains('gm-filter-bar--fixed');
      bar.classList.remove('gm-filter-bar--fixed');
      spacer.style.height = '0';
      bar.style.top = '';
      initialTop = bar.getBoundingClientRect().top + window.pageYOffset;
      barHeight = bar.offsetHeight;
      if (wasFixed) {
        bar.classList.add('gm-filter-bar--fixed');
        spacer.style.height = barHeight + 'px';
      }
    }

    function update() {
      var scrollY = window.pageYOffset;
      var shouldBeFixed = scrollY >= initialTop;

      if (shouldBeFixed) {
        bar.classList.add('gm-filter-bar--fixed');
        spacer.style.height = barHeight + 'px';
        bar.style.top = '0';
      } else {
        bar.classList.remove('gm-filter-bar--fixed');
        spacer.style.height = '0';
        bar.style.top = '';
      }
    }

    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', function () {
      recalc();
      update();
    }, { passive: true });

    recalc();
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
